export const answerTypes = {
    SmartCity: 'SmartCity',
    Logos: 'Logos',
    MultiD: 'MultiD',
    Course: 'Course',
    Rita: 'Rita'
};
